import { render, staticRenderFns } from "./Bip.vue?vue&type=template&id=d0fe8cae&scoped=true&"
import script from "./Bip.vue?vue&type=script&lang=js&"
export * from "./Bip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fe8cae",
  null
  
)

export default component.exports